import { Grid } from "@mui/material";
import Field from "components/Field";
import FieldRichText from "components/FieldRichText";
import { useIntl } from "react-intl";
import { SkuDeliveryMethodSettingProps } from "../SkuDeliveryMethodSetting";

interface PageContentSettingProps {
  item: SkuDeliveryMethodSettingProps;
}

const PageContentSetting = ({ item }: PageContentSettingProps) => {
  const { formatMessage: t } = useIntl();

  return (
    <Field
      name={`settingValues[${item.fieldIndex}].value`}
      required
    >
      {({ input, meta }) => (
        <Grid item xs={12} sx={{mt:3}}>
          <FieldRichText
            input={input}
            meta={meta}
            label={t({ id: "pageContent" })}
            required
            init={{
              height: 300,
            }}
          />
        </Grid>
      )}
    </Field>
  );
};

export default PageContentSetting;
